import * as React from "react";
import * as ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import AppRoutes, {
    AdminRoutes,
    AppRoutesForLocalUser,
    INTEGRATION_CATALOG_BASE_PATH,
    LOGIN_PATH,
    SimpleRoutes,
} from "AppRoutes";

import { QueryClient, QueryClientProvider } from "react-query";
import Toaster from "components/shared/Toaster";
import ErrorBoundary from "components/errorBoundary/ErrorBoundary";
import {
    createBrowserRouter,
    createRoutesFromElements,
    Navigate,
    PathRouteProps,
    Route,
    RouterProvider,
} from "react-router-dom";
import RequireLoginRoute, {
    RequiredAdminRoute,
    RequiredLocalUserRoute,
} from "components/route/ProtectedRoute";
import Layout from "components/layout/Layout";
import App from "App";

// Create a client
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
            retry: false, // do not retry failed queries
        },
    },
});

const getRouteWithChildren = (route: PathRouteProps, index: number) => {
    const { element, children, ...rest } = route;
    return (
        <Route key={index} {...rest} element={element}>
            {children}
        </Route>
    );
};

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route element={<App />}>
                {SimpleRoutes.map(getRouteWithChildren)}
                <Route element={<RequireLoginRoute redirectTo={LOGIN_PATH} />}>
                    <Route element={<Layout />}>
                        {AppRoutes.map(getRouteWithChildren)}

                        <Route
                            element={<RequiredLocalUserRoute redirectTo="" />}
                        >
                            {AppRoutesForLocalUser.map(getRouteWithChildren)}
                        </Route>

                        <Route element={<RequiredAdminRoute redirectTo="" />}>
                            {AdminRoutes.map(getRouteWithChildren)}
                        </Route>
                    </Route>
                </Route>
                <Route
                    path="*"
                    element={
                        <Navigate to={INTEGRATION_CATALOG_BASE_PATH} replace />
                    }
                />
            </Route>
        </>,
    ),
    {
        basename: process.env.PUBLIC_URL,
    },
);

const rootElement = document.getElementById("root");
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <ErrorBoundary>
                {/*
                 * The toaster creates a container just before the <body> tag and adds all toasts there, regardless of where the toaster component is initially placed in the DOM.
                 * Use the useToaster hook to add toasts to the toaster.
                 */}
                <Toaster />
                <QueryClientProvider client={queryClient}>
                    <RouterProvider router={router} />
                </QueryClientProvider>
            </ErrorBoundary>
        </React.StrictMode>,
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
